// 财务管理路由
export default {
	path: 'finance',
	component: () => import('@/components/RouterView'),
	redirect: 'noRedirect',
	meta: {
		title: '财务管理'
	},
	children: [{
			path: 'activity',
			component: () => import('@/components/RouterView'),
			redirect: 'noRedirect',
			children: [{
					path: 'receivables/audit',
					component: () => import('@/components/RouterView'),
					meta: {
						title: '演出收款信息审核'
					},
					redirect: '/finance/activity/receivables/audit/list',
					children: [{
						path: 'list',
						component: () => import('@/views/finance/activity/receivables/audit/list.vue'),
						meta: {
							title: '审核列表'
						},
					}, {
						path: ':id',
						component: () => import('@/views/finance/activity/receivables/audit/view.vue'),
						meta: {
							title: '审核详情'
						},
						props: true,
					}]
				}, {
					path: 'receivables/manage',
					component: () => import('@/components/RouterView'),
					meta: {
						title: '演出收款信息管理'
					},
					redirect: '/finance/activity/receivables/manage/list',
					children: [{
						path: 'list',
						component: () => import('@/views/finance/activity/receivables/manage/list'),
						meta: {
							title: '演出收款信息列表'
						},
					}, {
						path: 'edit/:id',
						component: () => import('@/views/finance/activity/receivables/manage/edit'),
						meta: {
							title: '演出收款信息'
						},
						props: true,
					}]
				}, {
					path: 'settlement',
					component: () => import('@/components/RouterView'),
					meta: {
						title: '演出结款查询'
					},
					redirect: '/finance/activity/settlement/list',
					children: [{
						path: 'list',
						component: () => import('@/views/finance/activity/settlement/list'),
						meta: {
							title: '演出结款查询列表'
						},
					}, {
						path: 'income/:id',
						component: () => import('@/views/finance/activity/settlement/income/detail'),
						meta: {
							title: '演出收入明细'
						},
						props: true,
					}]
				}, {
					path: 'settlementSheet',
					component: () => import('@/components/RouterView'),
					meta: {
						title: '演出结款单'
					},
					redirect: '/finance/activity/settlementSheet/list',
					children: [{
						path: 'list',
						component: () => import('@/views/finance/activity/settlementSheet/list'),
						meta: {
							title: '演出结款单'
						},
					}]
				},
				{
					path: 'refund/reconciliation',
					component: () => import('@/components/RouterView'),
					meta: {
						title: '退款对账管理',						
					},
					redirect: '/finance/activity/refund/reconciliation/list',
					children: [{
						path: 'list',
						component: () => import(
							'@/views/finance/activity/refund/reconciliation/list.vue'),
						meta: {
							title: '退款对账管理列表',
							activePage: '/finance/activity/refund/reconciliation'
						}
					}, {
						path: 'exception',
						component: () => import('@/views/finance/activity/refund/reconciliation/exception.vue'),
						meta: {
							title: '异常对账处理',
							activePage: '/finance/activity/refund/reconciliation'
						}						
					}]
				},
				{
					path: 'alt',
					component: () => import('@/components/RouterView'),
					redirect: '/finance/activity/alt/list',
					meta: {
						title: '演出定时购候补退款',
						activePage: '/finance/activity/alt/list'
					},
					children: [{
						path: 'list',
						component: () => import('@/views/finance/activity/alt/list'),
						meta: {
							title: '演出定时购候补退款列表'
						}
					}]
				}, {
					path: 'refund',
					component: () => import('@/components/RouterView'),
					meta: {
						title: '演出退款'
					},
					redirect: '/finance/activity/refund/list',
					children: [{
						path: 'list',
						component: () => import('@/views/finance/activity/refund/list'),
						meta: {
							title: '演出退款列表'
						}
					}]
				}
			]
		},
		{
			path: 'retention',
			component: () => import('@/components/RouterView'),
			redirect: 'noRedirect',
			children: [{
				path: 'manage',
				component: () => import('@/components/RouterView'),
				redirect: '/finance/retention/manage/list',
				meta: {
					title: '滞留款管理'
				},
				children: [{
					path: 'list',
					component: () => import('@/views/finance/retention/manage/list'),
					meta: {
						title: '滞留款管理列表'
					},
				}],
			}]
		}, {
			path: 'raise',
			component: () => import('@/components/RouterView'),
			redirect: 'noRedirect',
			children: [{
				path: 'receivables/audit',
				component: () => import('@/components/RouterView'),
				meta: {
					title: '众筹收款信息审核'
				},
				redirect: '/finance/raise/receivables/audit/list',
				children: [{
					path: 'list',
					component: () => import(
						'@/views/finance/raise/receivables/audit/list.vue'),
					meta: {
						title: '审核列表'
					},
				}, {
					path: ':id',
					component: () => import(
						'@/views/finance/raise/receivables/audit/view.vue'),
					meta: {
						title: '审核详情'
					},
					props: true,
				}]
			}, {
				path: 'receivables/manage',
				component: () => import('@/components/RouterView'),
				meta: {
					title: '众筹收款信息管理'
				},
				redirect: '/finance/raise/receivables/manage/list',
				children: [{
					path: 'list',
					component: () => import(
						'@/views/finance/raise/receivables/manage/list'),
					meta: {
						title: '众筹收款信息列表'
					},
				}, {
					path: 'edit/:id',
					component: () => import(
						'@/views/finance/raise/receivables/manage/edit'),
					meta: {
						title: '众筹收款信息'
					},
					props: true,
				}]
			}, {
				path: 'settlement',
				component: () => import('@/components/RouterView'),
				meta: {
					title: '众筹结款'
				},
				redirect: '/finance/raise/settlement/list',
				children: [{
					path: 'list',
					component: () => import('@/views/finance/raise/settlement/list'),
					meta: {
						title: '众筹结款列表'
					},
				}]
			}, {
				path: 'refund',
				component: () => import('@/components/RouterView'),
				meta: {
					title: '众筹退款'
				},
				redirect: '/finance/raise/refund/list',
				children: [{
					path: 'list',
					component: () => import('@/views/finance/raise/refund/list'),
					meta: {
						title: '众筹退款列表'
					}
				}]
			}]
		}, {
			path: 'batchRefundTask',
			component: () => import('@/views/finance/batchRefundTask'),
			meta: {
				title: '批量退款任务'
			}
		}, {
			path: 'goods',
			component: () => import('@/components/RouterView'),
			redirect: 'noRedirect',
			children: [{
				path: 'receivables/manage',
				component: () => import('@/components/RouterView'),
				meta: {
					title: '周边收款信息管理'
				},
				redirect: '/finance/goods/receivables/manage/list',
				children: [{
					path: 'list',
					component: () => import(
						'@/views/finance/goods/receivables/manage/list'),
					meta: {
						title: '周边收款信息列表'
					},
				}, {
					path: 'edit/:id',
					component: () => import(
						'@/views/finance/goods/receivables/manage/edit'),
					meta: {
						title: '管理周边收款信息'
					},
					props: true,
				}, {
					path: 'add',
					component: () => import(
						'@/views/finance/goods/receivables/manage/edit'),
					meta: {
						title: '新增周边收款信息'
					},
				}]
			}, {
				path: 'settlement/list',
				component: () => import('@/components/RouterView'),
				meta: {
					title: '周边结款'
				},
				redirect: '/finance/goods/settlement/list',
				children: [{
					path: '',
					component: () => import('@/views/finance/goods/settlement/list'),
					meta: {
						title: '周边结款列表'
					},
				}, {
					path: ':id',
					component: () => import(
						'@/views/finance/goods/settlement/list/dataView'),
					meta: {
						title: '周边结款信息'
					},
					props: true,
				}]
			}, {
				path: 'settlement/detail',
				component: () => import('@/components/RouterView'),
				meta: {
					title: '周边结款单'
				},
				redirect: '/finance/goods/settlement/detail',
				children: [{
					path: '',
					component: () => import('@/views/finance/goods/settlement/detail'),
					meta: {
						title: '周边结款单列表'
					},
				}, {
					path: ':id/:uid',
					component: () => import(
						'@/views/finance/goods/settlement/detail/details.vue'),
					meta: {
						title: '周边收入明细'
					},
					props: true
				}]
			}]
		}, {
			path: 'statement',
			component: () => import('@/components/RouterView'),
			redirect: '/finance/statement/list',
			children: [{
				path: 'list',
				component: () => import('@/views/finance/statement/list'),
				meta: {
					title: '收款对账单管理'
				},
			}, {
				path: 'detail',
				component: () => import('@/views/finance/statement/list/detail'),
				meta: {
					title: '对账单详情'
				},
			}, {
				path: 'abnormal/list',
				component: () => import('@/views/finance/statement/abnormal/list'),
				meta: {
					title: '收款对账单管理-异常收入对账处理'
				},
			}, {
				path: 'repeatOrder',
				component: () => import('@/components/RouterView'),
				// redirect: '/finance/statement/repeatOrder/list',
				// meta: {title: '重复支付订单', activePage:'/finance/statement/list'},
				children: [{
						path: 'list',
						component: () => import(
							'@/views/finance/statement/repeatOrder/list'),
						meta: {
							title: '收款对账单管理-重复支付订单列表',
							activePage: '/finance/statement/list'
						}
					},
					{
						path: 'edit/:id',
						component: () => import(
							'@/views/finance/statement/repeatOrder/edit'),
						meta: {
							title: '订单详情',
							activePage: '/finance/statement/list'
						},
						props: true
					}
				]
			}]
		}, {
			path: 'agent',
			component: () => import('@/components/RouterView'),
			redirect: 'noRedirect',
			children: [{
				path: 'manage',
				component: () => import('@/components/RouterView'),
				redirect: '/finance/agent/manage/list',
				meta: {
					title: '代理商管理'
				},
				children: [{
					path: 'list',
					component: () => import('@/views/finance/agent/manage/list'),
					meta: {
						title: '代理商列表'
					},
				}, {
					path: 'edit/:id',
					component: () => import('@/views/finance/agent/manage/edit'),
					meta: {
						title: '编辑代理商'
					},
					props: true
				}, {
					path: 'add',
					component: () => import('@/views/finance/agent/manage/edit'),
					meta: {
						title: '创建代理商'
					},
				}, {
					path: 'log/:id',
					component: () => import('@/views/finance/agent/manage/log'),
					meta: {
						title: '修改日志'
					},
					props: true
				}]
			}, {
				path: 'settlement',
				component: () => import('@/components/RouterView'),
				redirect: '/finance/agent/settlement/list',
				meta: {
					title: '代理商结算'
				},
				children: [{
					path: 'list',
					component: () => import('@/views/finance/agent/settlement/list'),
					meta: {
						title: '代理商结算列表'
					},
				}]
			}]
		},
		{
			path: 'raise',
			component: () => import('@/components/RouterView'),
			redirect: 'noRedirect',
			children: [{
				path: 'receivables/audit',
				component: () => import('@/components/RouterView'),
				meta: {
					title: '众筹收款信息审核'
				},
				redirect: '/finance/raise/receivables/audit/list',
				children: [{
					path: 'list',
					component: () => import('@/views/finance/raise/receivables/audit/list.vue'),
					meta: {
						title: '审核列表'
					},
				}, {
					path: ':id',
					component: () => import('@/views/finance/raise/receivables/audit/view.vue'),
					meta: {
						title: '审核详情'
					},
					props: true,
				}]
			}, {
				path: 'receivables/manage',
				component: () => import('@/components/RouterView'),
				meta: {
					title: '众筹收款信息管理'
				},
				redirect: '/finance/raise/receivables/manage/list',
				children: [{
					path: 'list',
					component: () => import('@/views/finance/raise/receivables/manage/list'),
					meta: {
						title: '众筹收款信息列表'
					},
				}, {
					path: 'edit/:id',
					component: () => import('@/views/finance/raise/receivables/manage/edit'),
					meta: {
						title: '众筹收款信息'
					},
					props: true,
				}]
			}, {
				path: 'settlement',
				component: () => import('@/components/RouterView'),
				meta: {
					title: '众筹结款'
				},
				redirect: '/finance/raise/settlement/list',
				children: [{
					path: 'list',
					component: () => import('@/views/finance/raise/settlement/list'),
					meta: {
						title: '众筹结款列表'
					},
				}]
			}, {
				path: 'refund',
				component: () => import('@/components/RouterView'),
				meta: {
					title: '众筹退款'
				},
				redirect: '/finance/raise/refund/list',
				children: [{
					path: 'list',
					component: () => import('@/views/finance/raise/refund/list'),
					meta: {
						title: '众筹退款列表'
					}
				}]
			}]
		}, {
			path: 'batchRefundTask',
			component: () => import('@/views/finance/batchRefundTask'),
			meta: {
				title: '批量退款任务'
			}
		}, {
			path: 'goods',
			component: () => import('@/components/RouterView'),
			redirect: 'noRedirect',
			children: [{
				path: 'receivables/manage',
				component: () => import('@/components/RouterView'),
				meta: {
					title: '周边收款信息管理'
				},
				redirect: '/finance/goods/receivables/manage/list',
				children: [{
					path: 'list',
					component: () => import('@/views/finance/goods/receivables/manage/list'),
					meta: {
						title: '周边收款信息列表'
					},
				}, {
					path: 'edit/:id',
					component: () => import('@/views/finance/goods/receivables/manage/edit'),
					meta: {
						title: '管理周边收款信息'
					},
					props: true,
				}, {
					path: 'add',
					component: () => import('@/views/finance/goods/receivables/manage/edit'),
					meta: {
						title: '新增周边收款信息'
					},
				}]
			}, {
				path: 'settlement/list',
				component: () => import('@/components/RouterView'),
				meta: {
					title: '周边结款'
				},
				redirect: '/finance/goods/settlement/list',
				children: [{
					path: '',
					component: () => import('@/views/finance/goods/settlement/list'),
					meta: {
						title: '周边结款列表'
					},
				}, {
					path: ':id',
					component: () => import('@/views/finance/goods/settlement/list/dataView'),
					meta: {
						title: '周边结款信息'
					},
					props: true,
				}]
			}, {
				path: 'settlement/detail',
				component: () => import('@/components/RouterView'),
				meta: {
					title: '周边结款单'
				},
				redirect: '/finance/goods/settlement/detail',
				children: [{
					path: '',
					component: () => import('@/views/finance/goods/settlement/detail'),
					meta: {
						title: '周边结款单列表'
					},
				}, {
					path: ':id/:uid',
					component: () => import('@/views/finance/goods/settlement/detail/details.vue'),
					meta: {
						title: '周边收入明细'
					},
					props: true
				}]
			}]
		}, {
			path: 'statement',
			component: () => import('@/components/RouterView'),
			redirect: '/finance/statement/list',
			children: [{
				path: 'list',
				component: () => import('@/views/finance/statement/list'),
				meta: {
					title: '收款对账单管理'
				},
			}, {
				path: 'detail',
				component: () => import('@/views/finance/statement/list/detail'),
				meta: {
					title: '对账单详情'
				},
			}, {
				path: 'abnormal/list',
				component: () => import('@/views/finance/statement/abnormal/list'),
				meta: {
					title: '收款对账单管理-异常收入对账处理'
				},
			}, {
				path: 'repeatOrder',
				component: () => import('@/components/RouterView'),
				// redirect: '/finance/statement/repeatOrder/list',
				// meta: {title: '重复支付订单', activePage:'/finance/statement/list'},
				children: [{
						path: 'list',
						component: () => import('@/views/finance/statement/repeatOrder/list'),
						meta: {
							title: '收款对账单管理-重复支付订单列表',
							activePage: '/finance/statement/list'
						}
					},
					{
						path: 'edit/:id',
						component: () => import('@/views/finance/statement/repeatOrder/edit'),
						meta: {
							title: '订单详情',
							activePage: '/finance/statement/list'
						},
						props: true
					}
				]
			}]
		}, {
			path: 'agent',
			component: () => import('@/components/RouterView'),
			redirect: 'noRedirect',
			children: [{
				path: 'manage',
				component: () => import('@/components/RouterView'),
				redirect: '/finance/agent/manage/list',
				meta: {
					title: '代理商管理'
				},
				children: [{
					path: 'list',
					component: () => import('@/views/finance/agent/manage/list'),
					meta: {
						title: '代理商列表'
					},
				}, {
					path: 'edit/:id',
					component: () => import('@/views/finance/agent/manage/edit'),
					meta: {
						title: '编辑代理商'
					},
					props: true
				}, {
					path: 'add',
					component: () => import('@/views/finance/agent/manage/edit'),
					meta: {
						title: '创建代理商'
					},
				}, {
					path: 'log/:id',
					component: () => import('@/views/finance/agent/manage/log'),
					meta: {
						title: '修改日志'
					},
					props: true
				}]
			}, {
				path: 'settlement',
				component: () => import('@/components/RouterView'),
				redirect: '/finance/agent/settlement/list',
				meta: {
					title: '代理商结算'
				},
				children: [{
					path: 'list',
					component: () => import('@/views/finance/agent/settlement/list'),
					meta: {
						title: '代理商结算列表'
					},
				}]
			}]
		}
	]
}